import { configureStore } from '@reduxjs/toolkit';
import { authApi } from 'api/authApi';
import { workshopApi } from 'api/workshopApi';
import { consultancyApi } from 'api/consultancyApi';
import { productApi } from 'api/productApi';
import { userApi } from 'api/userApi';
import { inquiryApi } from 'api/inquiryApi';
import { surveyApi } from 'api/surveyApi';
import {healthCheckerApi} from "api/healthCheckerApi";

const store = configureStore({
    reducer: {
        [authApi.reducerPath]: authApi.reducer,
        [workshopApi.reducerPath]: workshopApi.reducer,
        [consultancyApi.reducerPath]: consultancyApi.reducer,
        [productApi.reducerPath]: productApi.reducer,
        [userApi.reducerPath]: userApi.reducer,
        [inquiryApi.reducerPath]: inquiryApi.reducer,
        [surveyApi.reducerPath]: surveyApi.reducer,
        [healthCheckerApi.reducerPath]: healthCheckerApi.reducer,
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(
        authApi.middleware,
        workshopApi.middleware, 
        consultancyApi.middleware,
        productApi.middleware, 
        userApi.middleware, 
        inquiryApi.middleware,
        surveyApi.middleware,
        healthCheckerApi.middleware
    ),
});

export default store;
